export default __webpack_public_path__ + "static/media/user.a7c36e89.svg";